module.exports = __webpack_public_path__ + "static/SportsReservation-c7f4ef7a7ecb6124e3a416c20c20ac70.png";